import { gsap } from './gsapSetup';

function animateNavigation() {
    const nav = document.querySelector('.home .site-header');
    
    if (!nav) return;
    
    gsap.from(nav, {
        y: -100,
        opacity: 0,
        duration: 0.75,
        delay: 0.75,
        ease: "quad.out"
    });
}

document.fonts.ready.then(() => {
    animateNavigation();
})
